import React from 'react'
import { useParams } from 'react-router-dom'
import { EmptyCenteredLayout } from 'client-portal/components/PageLayout'
import { DownloadTestResultPdfButton } from 'sharedComponents/DownloadTestResultPdfButton'

export const DownloadPdf = () => {
  const { testId } = useParams<{ testId: string }>() ?? {}

  return (
    <EmptyCenteredLayout>
      <DownloadTestResultPdfButton
        testId={testId}
        shouldDownloadPdfOnMount
        appearance="filled"
        size="large"
      />
    </EmptyCenteredLayout>
  )
}
